import { Alert, Button, DatePicker, Flex, Form } from "antd";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axiosInstance from "../common/api";
import { requiredField } from "../common/common";

export default function () {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams();
    return (
        <Flex vertical gap={"middle"}>
            <Alert type="info" message="Questa procedura è irreversibile" />
            <Form
                layout="vertical"
                onFinish={(form) => {
                    const paymentDate = form.paymentDate.format("YYYY-MM-DD");
                    setLoading(true);
                    axiosInstance
                        .put(`paycheckBatchBankTransfer/${id}/state`, { paymentDate })
                        .then(() => navigate(-1))
                        .finally(() => setLoading(false));
                }}
            >
                <Form.Item
                    name={"paymentDate"}
                    label="Data di pagamento effettiva"
                    rules={[requiredField]}
                >
                    <DatePicker format="DD/MM/YYYY" />
                </Form.Item>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        Conferma
                    </Button>
                </Form.Item>
            </Form>
        </Flex>
    );
}
